import type {Api} from 'datatables.net';
import languageFR from 'datatables.net-plugins/i18n/fr-FR.json'
import {$, $$, createElement} from "./Dom.ts";

export const createDataTables = (selecteur: string | HTMLElement, options: any): Promise<{
                jQuery: any,
                datatable: Api,
            }> => {
    return new Promise((resolve) => {
        Promise.all([
            // @ts-ignore
            import("pdfmake/build/pdfmake.js"),
            // @ts-ignore
            import("datatables.net-dt"),
            // @ts-ignore
            import("jquery"),
            // @ts-ignore
            import("jszip"),
            // @ts-ignore
            import("pdfmake/build/vfs_fonts.js"),
            // @ts-ignore
            import("datatables.net-dt/css/dataTables.dataTables.min.css"),
            // @ts-ignore
            import("datatables.net-buttons-dt"),
            // @ts-ignore
            import("datatables.net-buttons/js/dataTables.buttons.mjs"),
            // @ts-ignore
            import("datatables.net-buttons/js/buttons.html5.mjs"),
            // @ts-ignore
            import("datatables.net-buttons/js/buttons.print.mjs"),
            // @ts-ignore
            import("datatables.net-buttons/js/buttons.colVis.mjs"),
            // @ts-ignore
            import("datatables.net-colreorder-dt"),
            // @ts-ignore
            import("datatables.net-fixedheader-dt"),
            // @ts-ignore
            import("datatables.net-searchbuilder-dt"),
            // @ts-ignore
            import("datatables.net-select-dt"),
        ]).then((results) => {
            const pdf = results[0].default
            const DataTable = results[1].default
            const jQuery = results[2].default
            const JSZip = results[3].default
            DataTable.Buttons.jszip(JSZip);
            DataTable.Buttons.pdfMake(pdf);

            const language = {...languageFR, ...options.language}
            const datatable = new DataTable(selecteur, {...options, language: language})

            resolve({
                jQuery,
                datatable,
            })
        })
    })
}

export function registerFiltreApi(api: Api<any>) {
    filtersOn(api)

    function reset() {
        filtersClear(api)
    }

    return reset
}

function filtersOn(api: Api<any>) {
    const context = api.context[0]
    api.search('');
    api.columns().search('').draw();

    const table = context.nTable
    const filterHeader = createElement("thead", ['filter'])
    const header = $('thead', table)!

    table.insertBefore(filterHeader, table.children[0])

    const tr = createElement('tr')
    tr.setAttribute("data-status", header.firstElementChild?.getAttribute('data-status') ?? "")
    filterHeader.appendChild(tr)
    // Populate the filter header
    $$('th', header).forEach((_thElement, index) => {
        const searchable = context.aoColumns[index].bSearchable
        const searchtype = context.aoColumns[index].searchtype
        const tablabel: any[] = []
        const th = createElement('th')

        if (searchable) {
            if (searchtype == "select") {
                const select = createElement('select', ['fr-select'])
                const emptyOption = createElement('option')
                select.appendChild(emptyOption)
                api.column(index).data().unique().sort().each((colContent) => {
                    let label: any
                    if (/^<./.test(colContent) === true) {
                        const element = new DOMParser().parseFromString(colContent, "text/html").firstChild as HTMLElement;
                        label = $('span[hidden]', element)?.innerText;
                        if (!label) {
                            label = $('span', element)?.innerText;
                        }
                    } else {
                        label = colContent;
                    }
                    let found = tablabel.find((element) => {
                        return label === element
                    })
                    if (!found) {
                        const option = createElement('option')
                        option.innerText = label.trim()
                        option.value = label.trim()
                        select.appendChild(option)
                        tablabel.push(label);
                    }
                })
                select.addEventListener('change', function (event: DOMEvent<HTMLInputElement>) {
                    api.column(index).search(event.target.value).draw();
                });
                th.appendChild(select)
            } else {
                const input = createElement('input', ['fr-input'])
                input.addEventListener('keyup', function (event: DOMEvent<HTMLInputElement>) {
                    api.column(index).search(event.target.value).draw();
                });
                th.appendChild(input)
            }
        }
        tr.appendChild(th)
    })

    return api;
}

function filtersClear(api: Api<any>) {
    api.search('');
    api.columns().search('').draw();
    const table = api.context[0].nTable
    $$<HTMLSelectElement>('select', table).forEach((select) => select.value = "")
    $$<HTMLInputElement>('input', table).forEach((select) => select.value = "")
}